<template>
  <div class="container">
    <div class="conmonContent">
      <div class="w1600">
        <div class="proTop d-flex j-sb a-start">
          <div class="ptLeft">
            <h3 class="font36 corfff h3">{{ $t("adminMenu.ip") }}</h3>
          </div>
          <!-- 筛选 -->
          <div class="searchblock">
						<search></search>
				  </div>
        </div>

        <!-- 主体列表内容 -->
        <div class="psLeftContent d-flex f-wrap">
          <!-- IP产品 -->
          <div class="item w100">
            <div class="text bd10 p3">
              <div class="table font-light line-mn">
                <dl>
                  <dt class="d-flex">
                    <span>{{ $t("admin.productName") }}</span>
                    <span>{{ $t("admin.createDate") }}</span>
                    <span>{{ $t("admin.handle") }}</span>
                  </dt>
                  <dd
                    class="d-flex"
                    v-for="(item, index) in ProductVoList"
                    :key="index"
                  >
                    <span class="nowrap2"
                      ><a
                        @click="goToPage('/ipProductDetail?id=' + item.id)"
                        class="link pointer"
                        >{{ item.name }}</a
                      ></span
                    >
                    <span>{{ item.time }}</span>
                    <span class="d-flex j-center a-center">
                      <a
                        class="d pointer"
                        @click="goToPage('/ipProductDetail?id=' + item.id)"
                      ></a>
                    </span>
                  </dd>
                </dl>
              </div>
            </div>
            <!-- 分页 -->
            <div class="pagination">
              <el-pagination
                @current-change="handleCurrentChange"
                :page-size="10"
                layout="prev, pager, next"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IpProduct",
  components: {},
  data() {
    return {
      // 产品
      itemid:"",
      ProductVoList: [],
      // 分页
      pagination: {
        pageNo: 1,
        pageSize: 10,
        productId:""
      },
      // 数量
      total: 0,
    };
  },

  created() {
    this.pagination.productId=this.$route.query.id;
    // 获取IP产品
    this.getProductVoList();
  },

  methods: {
    // 页面跳转
    goToPage(path, query = {}) {
      this.$router.push({
        path,
        query,
      });
    },

    // 获取IP产品
    getProductVoList() {
      this.$axios
        .post("member/ipPage", this.pagination)
        .then((res) => {
          this.ProductVoList = res.data.list;
          this.total = res.data.total;
        })
        .catch((err) => {});
    },

    // 点击翻页
    handleCurrentChange(current) {
      this.pagination.pageNo = current;
      // 更新
      this.getProductVoList();
    },
  },
};
</script>

<style lang="less" scoped>
.proTop {
  padding: 0.5rem 0;
  .tags {
    span {
      display: inline-block;
      padding: 0.05rem 0.08rem;
      border-radius: 0.15rem;
      background: #5794f8;
      color: #fff;
      margin-right: 0.1rem;
    }
  }
  .cTopFrom {
    margin: 0;
  }
  @media (max-width: 1200px) {
    display: block;
    .cTopFrom {
      margin: 0.3rem auto 0;
    }
  }
}
.psLeftContent {
  width: 100%;
  .toPage {
    margin-left: 0.15rem;
    input {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 5px;
      background: #fff;
      text-align: center;
      margin: 0 5px;
      padding: 0 5px;
    }
  }
  .item {
    width: 50%;
    margin-bottom: 0.2rem;
    &.w100 {
      width: 100%;
      dd:hover,
      dd:hover a {
        color: #2657db;
      }
    }
  }
  .table {
    dl {
      dt,
      dd {
        padding: 0.22rem 0;
      }
      dt {
        background: #f2f5fa;
        border-radius: 5px;
        span:nth-of-type(1) {
          padding-left: 0.15rem;
        }
      }
      dd {
        &:not(:last-child) {
          border-bottom: solid 1px #eee;
        }
        span:nth-of-type(1) {
          position: relative;
          padding-left: 0.2rem;
          &:after {
            content: "";
            position: absolute;
            left: 0;
            top: 0.1rem;
            width: 0.04rem;
            height: 0.04rem;
            background: #2657db;
          }
        }
      }
      span {
        .d {
          width: 0.19rem;
          height: 0.14rem;
          background: url(@/assets/Icons/look.png) no-repeat center/100% 100%;
          &:hover {
            background-image: url(@/assets/Icons/lookBlue.png);
          }
        }
        &:nth-of-type(1) {
          width: calc(87% - 1rem);
        }
        &:nth-of-type(2) {
          width: 13%;
        }
        &:last-child {
          width: 1rem;
          text-align: center;
        }
      }
    }
  }
}
@media (max-width: 640px) {
  padding: 0.2rem;
  .psLeftContent {
    .table {
      dl {
        span {
          &:nth-of-type(1) {
            width: 3rem;
            padding-right: 0.2rem;
          }
          &:nth-of-type(2) {
            width: 1.2rem;
          }
        }
      }
    }
  }
}
</style>
